export default "__VITE_ASSET__iJx89gut__"